// extracted by mini-css-extract-plugin
export default {"readme_logo":"readme_readme_logo__96Y8v","markdown_container":"readme_markdown_container__VzCyg"};